import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73df9bae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide-renderer"
};
import GuideTitle from '@/components/guide/Title.vue';
import GuideSubtitle from '@/components/guide/Subtitle.vue';
import GuideText from '@/components/guide/TextBlock.vue';
import GuideImageList from '@/components/guide/ImageList.vue';
import GuideSubItem from '@/components/guide/SubItem.vue';
import GuideIndexRow from '@/components/guide/IndexRow.vue';
import GuideMenu from '@/components/guide/MenuItem.vue';
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    function resolveType(type) {
      switch (type) {
        case 'title':
          return GuideTitle;
        case 'subtitle':
          return GuideSubtitle;
        case 'text':
          return GuideText;
        case 'image':
          return GuideImageList;
        case 'subitem':
          return GuideSubItem;
        case 'index':
          return GuideIndexRow;
        case 'menu':
          return GuideMenu;
        default:
          return GuideText;
      }
    }
    function mapProps(item) {
      if (!item) return {};
      if (item.type === 'menu') {
        return {
          title: item.title || '',
          content: item.content || []
        };
      }
      if (item.type === 'image') {
        return {
          content: Array.isArray(item.content) ? item.content : [],
          width: item.width || '100%',
          link: item.link || '',
          links: Array.isArray(item.links) ? item.links : []
        };
      }
      if (item.type === 'index') {
        return {
          content: item.content || '',
          label: typeof item.index !== 'undefined' ? String(item.index) : ''
        };
      }
      return {
        content: item.content || ''
      };
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, idx) => {
        return _openBlock(), _createBlock(_resolveDynamicComponent(resolveType(item.type)), _mergeProps({
          key: idx
        }, mapProps(item)), null, 16);
      }), 128))]);
    };
  }
};